export const characters = [
  {
    id: 'santa-1',
    name: 'Santa 1',
    image: '/assets/characters/santa-1.jpg'
  },
  {
    id: 'santa-2',
    name: 'Santa 2',
    image: '/assets/characters/santa-2.jpg'
  },
  {
    id: 'mrs-santa',
    name: 'Mrs. Santa',
    image: '/assets/characters/mrs-santa.jpg'
  },
  {
    id: 'elf',
    name: 'Elf',
    image: '/assets/characters/elf.jpg'
  },
  {
    id: 'grinch',
    name: 'Grinch',
    image: '/assets/characters/grinch.jpg'
  },
  {
    id: 'rudolph',
    name: 'Rudolph',
    image: '/assets/characters/rudolph.jpg'
  }
];